import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'gatsby';

import styles from './Topics.module.scss';

const list = [
  {name: 'Coronavírus', slug: 'coronavirus'},
  {name: 'Economia', slug: 'economia'},
  {name: 'Mulheres', slug: 'mulheres'},
  {name: 'Educação', slug: 'educacao'},
  {name: 'Saúde', slug: 'saude'},
  {name: 'Segurança pública', slug: 'seguranca'},
  {name: 'Cultura', slug: 'cultura'},
  {name: 'LGBT', slug: 'lgbt'},
  {name: 'Negras e negros', slug: 'negritude'},
  {name: 'Pessoas com Deficiência', slug: 'pcd'},
  {name: 'Ciência e Tecnologia', slug: 'ciencia-e-tecnologia'},
  {name: 'Política de drogas', slug: 'drogas'},
  {name: 'Meio ambiente', slug: 'meio-ambiente'},
  {name: 'Relações internacionais', slug: 'internacional'},
  {name: 'Política urbana', slug: 'politica-urbana'},
  {name: 'Segurança alimentar', slug: 'seguranca-alimentar'},
];

const Topics = ({page}) => (
  <section className={styles.container + (page ? ` ${styles.full}` : '')}>
    <div className="wrap">
      <h2 className={styles.title}>
        <strong>Projetos do mandato</strong>
      </h2>

      <ul className={styles.list}>
        {list.map((item, i) => (
          <li key={i}>
            <Link className={styles.item} to={`/mandato/${item.slug}/`}>
              <div className={styles.icon}>
                <img alt={item.name} src={require(`../images/platform/${item.slug}.svg`)} />
              </div>
              <div className={styles.name}>{item.name}</div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

Topics.propTypes = {
  page: PropTypes.bool,
};

export default Topics;
